import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ContactForm } from '../components/ContactForm';
import { ContactInfo } from '../components/ContactInfo';
import { motion } from 'framer-motion';
import { MessageCircle, Sparkles } from 'lucide-react';
export function Contact() {
  return <div className="min-h-screen bg-[#0B1014] text-white flex flex-col" data-id="element-876">
      <Header data-id="element-877" />

      {/* Hero Section */}
      <div className="relative pt-32 pb-16 overflow-hidden" data-id="element-878">
        <div className="absolute inset-0 bg-gradient-to-b from-[#DDA247]/5 via-transparent to-transparent" data-id="element-879" />
        <div className="absolute top-20 right-1/4 w-96 h-96 bg-[#DDA247]/10 rounded-full blur-[120px]" data-id="element-880" />

        <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-881">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-3xl mx-auto text-center" data-id="element-882">
            <div className="flex items-center justify-center gap-3 mb-6" data-id="element-883">
              <Sparkles className="w-6 h-6 text-[#DDA247]" data-id="element-884" />
              <span className="text-sm text-[#DDA247] uppercase tracking-[0.2em] font-medium" data-id="element-885">
                Get In Touch
              </span>
              <Sparkles className="w-6 h-6 text-[#DDA247]" data-id="element-886" />
            </div>
            <h1 className="text-4xl md:text-6xl font-bold text-white uppercase tracking-tight mb-6 leading-tight" data-id="element-887">
              Contact Us
            </h1>
            <p className="text-gray-400 text-base md:text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-888">
              Have questions about reservations, events, or our services? We're
              here to help make your experience unforgettable.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Main Content */}
      <main className="flex-1 pb-20 px-4 md:px-6 container mx-auto" data-id="element-889">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12" data-id="element-890">
          {/* Contact Form - Takes up 3 columns */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2,
          duration: 0.6
        }} className="lg:col-span-3" data-id="element-891">
            <div className="bg-gradient-to-br from-[#0F161B] to-[#0B1014] border border-white/10 rounded-3xl p-8 md:p-10 shadow-2xl" data-id="element-892">
              <div className="flex items-center gap-3 mb-8" data-id="element-893">
                <div className="w-12 h-12 bg-[#DDA247]/10 rounded-xl flex items-center justify-center" data-id="element-894">
                  <MessageCircle className="w-6 h-6 text-[#DDA247]" data-id="element-895" />
                </div>
                <div data-id="element-896">
                  <h2 className="text-2xl font-bold text-white uppercase tracking-wide" data-id="element-897">
                    Send Us a Message
                  </h2>
                  <p className="text-sm text-gray-500" data-id="element-898">
                    Fill out the form below and we'll respond shortly
                  </p>
                </div>
              </div>

              <ContactForm data-id="element-899" />
            </div>
          </motion.div>

          {/* Contact Info - Takes up 2 columns */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.3,
          duration: 0.6
        }} className="lg:col-span-2" data-id="element-900">
            <ContactInfo data-id="element-901" />
          </motion.div>
        </div>

        {/* FAQ Teaser */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5
      }} className="mt-16 bg-gradient-to-r from-[#DDA247]/10 via-[#DDA247]/5 to-transparent border border-[#DDA247]/20 rounded-2xl p-8 text-center" data-id="element-902">
          <h3 className="text-xl font-bold text-white mb-3 uppercase tracking-wide" data-id="element-903">
            Looking for Quick Answers?
          </h3>
          <p className="text-gray-400 mb-6 max-w-2xl mx-auto" data-id="element-904">
            Check out our frequently asked questions for instant information
            about reservations, dress code, parking, and more.
          </p>
          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="px-8 py-3 bg-[#DDA247] text-[#0B1014] font-bold rounded-xl uppercase tracking-wider hover:bg-white transition-colors" data-id="element-905">
            View FAQ
          </motion.button>
        </motion.div>
      </main>

      <Footer data-id="element-906" />
    </div>;
}